import React from "react";
import { motion } from "framer-motion";
import CountdownTimer from "./CountdownTimer";

export default function HeroV2({ onScrollToForm, loggedIn, config }) {
  return (
    <>
      <style>{`
        .hero-v2-section::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.2) 30%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.6) 80%, #000 100%);
          pointer-events: none;
          z-index: 0;
        }
      `}</style>
      <section
        dir="rtl"
        className="hero-v2-section"
        style={{
          backgroundImage: `url('${config?.bg_image ?? "/images/giveaway/mondial_bg.png"}')`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          paddingTop: "100px",
          paddingBottom: "0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="max-w-5xl mx-auto px-6 relative z-10">

          {/* Pre-headline */}
           <motion.div
             initial={{ opacity: 0, y: 14 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ delay: 0.05 }}
             className="text-base md:text-lg font-semibold mb-4 leading-relaxed max-w-3xl text-right"
             style={{ color: "#fff", textShadow: "0 1px 4px rgba(0,0,0,0.6)" }}
           >
             {config?.pre_headline != null ? (
               <p>
                 {config.pre_headline}
                 {config?.pre_headline_accent != null && (
                   <span style={{ color: "#c8f135" }}>{config.pre_headline_accent}</span>
                 )}
               </p>
             ) : (
               <p>
                 הדרך שלכם למונדיאל 2026 בארה"ב <span style={{ color: "#c8f135" }}>מתחילה כאן!</span>
               </p>
             )}
             <p>
               {`הגעתם למקום הנכון. בקהילת Mom3ntum, הפעילות שלכם ברשת הופכת לחוויות בלתי נשכחות. מצטרפים, משלימים משימות, צוברים נקודות – ומתקדמים לעבר זוג כרטיסים למשחק הפתיחה, עלינו!`}
             </p>
           </motion.div>

          {/* Main headline */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.12 }}
            className="mb-3 text-right"
          >
            <h1
              className="font-bold leading-tight text-white"
              style={{ fontSize: "clamp(2.5rem, 5vw, 76px)", lineHeight: "1.1" }}
            >
              {config?.headline ?? 'זוג כרטיסים למונדיאל ארה"ב 2026'}
            </h1>

            {/* Match info: Team A vs Team B with flags */}
            <div className="flex items-center gap-4 mt-4 mb-2">
              <img src={config?.team_a?.flag ?? "/images/giveaway/usa_flag.png"} alt={config?.team_a?.name ?? "USA"} className="w-12 h-12 rounded-full object-cover" />
              <span
                className="font-semibold text-white"
                style={{ fontSize: "clamp(1.5rem, 3vw, 56px)", lineHeight: "1.1" }}
              >
                {`${config?.team_a?.name ?? 'ארה"ב'}  -  ${config?.team_b?.name ?? 'פרגוואי'}`}
              </span>
              <img src={config?.team_b?.flag ?? "/images/giveaway/paraguay_flag.png"} alt={config?.team_b?.name ?? "Paraguay"} className="w-12 h-12 rounded-full object-cover" />
            </div>

            <h2
              className="font-bold"
              style={{ fontSize: "clamp(2.8rem, 5.5vw, 80px)", lineHeight: "1.1", color: "#C8F135" }}
            >
              {config?.sub_headline ?? "אנחנו מגיעים."}
            </h2>
          </motion.div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.22 }}
            className="flex flex-col sm:flex-row items-start gap-3 mb-12 mt-8"
          >
            <button
              onClick={onScrollToForm}
              className="inline-flex items-center gap-2 font-black text-base px-8 py-4 rounded-full transition-all duration-200 active:scale-95"
              style={{
                background: "#C8F135",
                color: "#000",
                boxShadow: "0px 8px 32px rgba(200,241,53,0.35)",
              }}
            >
              {loggedIn ? "👉 רוצה להתחיל לצבור נקודות?" : (config?.cta_text ?? "הצטרפו עכשיו")}
            </button>
          </motion.div>

          {/* Countdown */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35 }}
            className="border-t pb-10 pt-8"
            style={{ borderColor: "rgba(255,255,255,0.08)" }}
          >
            <p className="text-center text-xs font-black uppercase tracking-widest mb-6" style={{ color: "#BEBEBE", letterSpacing: "1.2px" }}>
              נשאר עד סיום המבצע
            </p>
            <CountdownTimer />
            <p className="text-center text-sm font-bold uppercase tracking-widest mt-5" style={{ color: "#BEBEBE", letterSpacing: "1.2px" }}>
              המבצע פעיל עד 31.3.2026
            </p>
          </motion.div>
        </div>
      </section>
    </>
  );
}